<template>
  <div class="wrapper"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style lang="stylus" scoped>
@import '~common/stylus/variable';
@import '~common/stylus/mixin';

.wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  background: #ffffff;
}
</style>
